const getLowestPriceVendorOptions = (vendorOptions: VendorOptionState[]) => {
  let lowestPriceVendorOption = vendorOptions[0];

  vendorOptions.forEach((vendorOption) => {
    if (vendorOption.productGrandTotal < lowestPriceVendorOption.productGrandTotal && vendorOption.inStock) {
      lowestPriceVendorOption = vendorOption;
    }
  });

  return lowestPriceVendorOption;
};

export default getLowestPriceVendorOptions;
